export default __webpack_public_path__ + "static/media/carousel-1-pic-2.428c6b41.jpg";